import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Risk Assessment Service
 * Routes dynamically based on role_id from localStorage user.role.id
 */

const riskAssessmentService = {
  /**
   * Get all risk assessments for a residence
   */
  getRiskAssessmentsByResidence: async (residenceId) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.get(`/${routePath}/residences/${residenceId}/risk-assessments`);
      return response.data;
    } catch (error) {
      console.error('Error fetching risk assessments:', error);
      throw error;
    }
  },

  /**
   * Create new risk assessment
   */
  createRiskAssessment: async (residenceId, assessmentData) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.post(
        `/${routePath}/residences/${residenceId}/risk-assessments`,
        assessmentData
      );
      return response.data;
    } catch (error) {
      console.error('Error creating risk assessment:', error);
      throw error;
    }
  },

  /**
   * Update/Review risk assessment
   */
  updateRiskAssessment: async (residenceId, riskAssessmentId, assessmentData) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.put(
        `/${routePath}/residences/${residenceId}/risk-assessments/${riskAssessmentId}`,
        assessmentData
      );
      return response.data;
    } catch (error) {
      console.error('Error updating risk assessment:', error);
      throw error;
    }
  },

  /**
   * Delete risk assessment
   */
  deleteRiskAssessment: async (residenceId, riskAssessmentId) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.delete(
        `/${routePath}/residences/${residenceId}/risk-assessments/${riskAssessmentId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting risk assessment:', error);
      throw error;
    }
  },

  /**
   * Get assessment types for a resident (master types + this resident's own)
   */
  getAssessmentTypes: async (residenceId) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.get(`/${routePath}/residences/${residenceId}/risk-assessment-types`);
      return response.data;
    } catch (error) {
      console.error('Error fetching assessment types:', error);
      throw error;
    }
  },

  /**
   * Add an assessment type for a specific resident
   */
  createAssessmentType: async (residenceId, name) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.post(
        `/${routePath}/residences/${residenceId}/risk-assessment-types`,
        { name }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating assessment type:', error);
      throw error;
    }
  },
};

export default riskAssessmentService;
